import { Spinner } from '@design-system';
import { useTranslation } from 'next-i18next';
import React from 'react';

export const Loading = () => {
  const { t } = useTranslation('private');

  return (
    <div className="flex h-screen flex-col items-center justify-center text-center text-white">
      <p className="font-bold">{t('unlock.loading.title')}</p>
      <p>{t('unlock.loading.description')}</p>
      <div className="pt-4 md:pt-6">
        <Spinner />
      </div>
    </div>
  );
};
